import {useUser} from '../../auth/ui/use-user';
import {queryClient} from '@common/http/query-client';

export function useBillingUser() {
  const query = useUser('me', {
    with: ['subscriptions.product', 'subscriptions.price'],
  });

  const subscription = query.data?.user.subscriptions?.find(sub => {
    const expiryDate = sub.ends_at
      ? new Date(sub.ends_at)
      : (sub.renews_at ? new Date(sub.renews_at) : null);
    if (!expiryDate) return true;
    return expiryDate > new Date();
  }) || query.data?.user.subscriptions?.[0];

  return {subscription, isLoading: query.isLoading, user: query.data?.user};
}

export function invalidateBillingUserQuery() {
  queryClient.invalidateQueries({queryKey: ['users']});
}
